module.exports = __webpack_public_path__ + "img/benefit-curve-desktop.2400108f.svg";